import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { MakeFields } from './validation/fields';
import FormBase from '../../../../common/FormBase/index';
import Form from './Form';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { schema } from './validation/schema';

const GoldSilverDispatchCharge = ({ ...props }) => {
  const { mobile, motiveId, issueForm, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const rut = params.get('rut');

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm={issueForm}
        mobile={mobile}
        title=""
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            fields={MakeFields(rut)}
          />
        }
        data={data}
        fields={MakeFields(rut)}
        formName="goldSilverDispacthCharge"
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        schema={schema}
        motiveId={motiveId}
        typeId={typeId}
      />
    </React.Fragment>
  );
};

GoldSilverDispatchCharge.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueForm: PropTypes.bool,
  typeId: PropTypes.string,
};

export default GoldSilverDispatchCharge;
